import React from "react";
import trans from "../../../../utils";
import PopupBodyItem from "../../../Helpers/Popup/PopupParts/PopupBodyItem";
import { formatDate } from "../../../../JsHelpers/DateFormat";

export default function PermissionsInf({ values = {} }) {
	const getValue = (value, defaultValue = "-----") =>
		value ? value : defaultValue;

	const {
		name = "",
		description = "",
		modules = "",
		resources = "",
		actions = "",
		submodules = "",
		hierarchyLevels = "",
		rolePermissions = "",
		createdBy = "",
		updatedBy = "",
		createdAt = "",
		updatedAt = "",
	} = values;
	const formattedCreatedAt = createdAt
		? formatDate(createdAt).formattedDate
		: "-----";
	const formattedUpdatedAt = updatedAt
		? formatDate(updatedAt).formattedDate
		: "-----";
	let subModules = Array.isArray(submodules)
		? submodules.map((item) => item).join(", ")
		: "";
	let hierarchylevels = Array.isArray(hierarchyLevels)
		? hierarchyLevels.map((item) => item).join(", ")
		: "";
	let rolepermissions = Array.isArray(rolePermissions)
		? rolePermissions.map((item) => item?.role?.name).join(", ")
		: "";
	return (
		<div>
			<p className="fs-16 fw-700 brand-700 text-uppercase">
				{trans("Basic Information")}
			</p>
			<div className="row">
				<div className="col-lg-6">
					<div className="display-border">
						<PopupBodyItem title={trans("Name")} item={getValue(name)} />
						<PopupBodyItem title={trans("Modules")} item={getValue(modules)} />
						<PopupBodyItem
							title={trans("Access Type")}
							item={getValue(actions)}
						/>
						<PopupBodyItem
							title={trans("Hierarchy Level")}
							item={getValue(hierarchylevels)}
						/>
						<PopupBodyItem
							title={trans("Created By")}
							item={getValue(createdBy?.name || "- - - -")}
						/>
						<PopupBodyItem
							title={trans("updated by")}
							item={getValue(updatedBy?.name || "- - - -")}
						/>
					</div>
				</div>
				<div className="col-lg-6">
					<div className="display-border">
						<PopupBodyItem
							title={trans("Description")}
							item={getValue(description)}
						/>
						<PopupBodyItem
							title={trans("Sub-Modules")}
							item={getValue(subModules)}
						/>

						<PopupBodyItem
							title={trans("Resources")}
							item={getValue(resources)}
						/>
						<PopupBodyItem
							title={trans("roles")}
							item={getValue(rolepermissions)}
						/>
						<PopupBodyItem
							title={trans("Created At")}
							item={getValue(formattedCreatedAt)}
						/>
						<PopupBodyItem
							title={trans("updated at")}
							item={getValue(formattedUpdatedAt)}
						/>
					</div>
				</div>
			</div>
		</div>
	);
}
